import service from "./service"

const getMediaDocumentUrl = async ({ backgroundRequestId, requestKey, documentKey }) =>
    service({ backgroundRequestId, requestKey, documentKey })

export default getMediaDocumentUrl
